(() => {
  if (window.eighteenCatalogInitialized) return;
  window.eighteenCatalogInitialized = true;
  const completeCatalog = async (section, source, signal) => {
    const grid = section.querySelector('[data-catalog-products]');
    let pagination = section.querySelector('[data-catalog-pagination]');
    const visited = new Set();
    const key = (card) => card.querySelector('.product__title a')?.href.split('/products/')[1]?.split('?')[0];
    const seen = new Set([...grid.querySelectorAll('.product')].map(key));
    while (pagination?.querySelector('.next a')) {
      pagination.hidden = true;
      const next = new URL(pagination.querySelector('.next a').href, location.origin);
      if (visited.has(next.href)) throw new Error('Repeated catalog page');
      visited.add(next.href);
      next.searchParams.set('section_id', 'collection-template');
      const preview = new URL(source).searchParams.get('preview_theme_id');
      if (preview) next.searchParams.set('preview_theme_id', preview);
      const response = await fetch(next, {signal});
      if (!response.ok) throw new Error('Catalog page unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const nextGrid = doc.querySelector('[data-catalog-products]');
      if (!nextGrid || signal?.aborted) throw new Error('Catalog page unavailable');
      const cards = [...nextGrid.querySelectorAll('.product')];
      if (!cards.length) throw new Error('Missing catalog products');
      for (const card of cards) {
        const id = key(card);
        if (!id) throw new Error('Unknown catalog product');
        if (!seen.has(id)) {
          seen.add(id);
          grid.append(card);
        }
      }
      const nextPagination = doc.querySelector('[data-catalog-pagination]');
      if (nextPagination) {
        nextPagination.hidden = true;
        pagination.replaceWith(nextPagination);
        pagination = nextPagination;
      } else {
        pagination.remove();
        pagination = null;
      }
    }
    if (grid.querySelectorAll('.product').length < Number(grid.dataset.totalProducts)) throw new Error('Incomplete catalog');
    if (pagination) pagination.remove();
  };
  if (!document.querySelector('[data-home-catalog]')) {
    const url = new URL(location.href);
    if (document.querySelector('[data-section-type="collection-template"]') && !url.searchParams.has('filter.v.availability') && url.searchParams.get('catalog_availability') !== 'all') {
      url.searchParams.set('filter.v.availability', '1');
      url.searchParams.delete('page');
      location.replace(url);
      return;
    }
    if (url.searchParams.has('page') && !url.searchParams.has('catalog_fallback')) {
      url.searchParams.delete('page');
      location.replace(url);
      return;
    }
    document.querySelectorAll('[data-section-type="collection-template"]').forEach(async (section) => {
      section.setAttribute('aria-busy', 'true');
      try {
        await completeCatalog(section, url);
      } catch (error) {
        const pagination = section.querySelector('[data-catalog-pagination]');
        if (pagination) {
          pagination.hidden = false;
          pagination.querySelectorAll('a').forEach((link) => {
            const fallback = new URL(link.href);
            fallback.searchParams.set('catalog_fallback', '1');
            link.href = fallback.href;
          });
        }
      } finally {
        section.removeAttribute('aria-busy');
      }
    });
  }
  document.querySelectorAll('[data-home-catalog]').forEach((catalog) => {
    if (catalog.dataset.initialized) return;
    catalog.dataset.initialized = 'true';
    const results = catalog.querySelector('[data-home-results]');
    const base = new URL(catalog.dataset.collectionUrl, location.origin);
    const initial = new URL(location.href);
    let current = new URL(base);
    let controller;
    const queryKeys = ['sort_by', 'filter.v.availability', 'catalog_availability', 'preview_theme_id'];
    if (initial.searchParams.has('page')) {
      initial.searchParams.delete('page');
      history.replaceState({}, '', initial);
    }
    queryKeys.forEach((key) => {
      if (initial.searchParams.has(key)) current.searchParams.set(key, initial.searchParams.get(key));
    });
    if (!current.searchParams.has('filter.v.availability') && current.searchParams.get('catalog_availability') !== 'all') current.searchParams.set('filter.v.availability', '1');
    if (!current.searchParams.has('sort_by')) current.searchParams.set('sort_by', 'created-descending');
    const load = async (url, push, focus) => {
      if (controller) controller.abort();
      controller = new AbortController();
      const signal = controller.signal;
      results.setAttribute('aria-busy', 'true');
      const request = new URL(url);
      request.searchParams.set('section_id', catalog.dataset.resultsSection);
      try {
        const response = await fetch(request, {signal});
        if (!response.ok) throw new Error('Catalog unavailable');
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const section = doc.querySelector('[data-section-type="collection-template"]');
        if (!section || !section.querySelector('[data-catalog-products]')) throw new Error('Catalog unavailable');
        await completeCatalog(section, url, signal);
        if (signal.aborted) return;
        section.removeAttribute('data-section-type');
        section.removeAttribute('data-section-id');
        section.querySelectorAll('script').forEach((script) => script.remove());
        results.replaceChildren(section);
        current = new URL(url);
        results.removeAttribute('aria-busy');
        const inStock = current.searchParams.get('filter.v.availability') === '1';
        results.querySelectorAll('[data-availability]').forEach((link) => {
          const active = (link.dataset.availability === '1') === inStock;
          link.classList.toggle('is-selected', active);
          if (active) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
        if (push) {
          const home = new URL(location.href);
          queryKeys.filter((key) => key !== 'preview_theme_id').forEach((key) => {
            home.searchParams.delete(key);
            if (current.searchParams.has(key)) home.searchParams.set(key, current.searchParams.get(key));
          });
          history.pushState({}, '', home);
        }
        if (focus) {
          const target = results.querySelector(focus);
          if (target) target.focus({preventScroll: true});
        }
      } catch (error) {
        if (error.name !== 'AbortError') location.assign(url.href);
      }
    };
    catalog.addEventListener('change', (event) => {
      if (event.target.name !== 'sort_by') return;
      event.stopImmediatePropagation();
      const url = new URL(current);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      load(url, true, '[name="sort_by"]');
    }, true);
    catalog.addEventListener('click', (event) => {
      const link = event.target.closest('[data-availability]');
      if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const url = new URL(current);
      if (link.dataset.availability) {
        url.searchParams.delete('page');
        url.searchParams.delete('filter.v.availability');
        url.searchParams.delete('catalog_availability');
        if (link.dataset.availability === '1') url.searchParams.set('filter.v.availability', '1');
        else url.searchParams.set('catalog_availability', 'all');
      } else {
        const page = new URL(link.href).searchParams.get('page');
        if (page) url.searchParams.set('page', page);
        else url.searchParams.delete('page');
      }
      load(url, true, link.dataset.availability ? '[data-availability="' + link.dataset.availability + '"]' : '[name="sort_by"]');
    }, true);
    window.addEventListener('popstate', () => {
      const url = new URL(base);
      const home = new URL(location.href);
      queryKeys.forEach((key) => {
        if (home.searchParams.has(key)) url.searchParams.set(key, home.searchParams.get(key));
      });
      if (!url.searchParams.has('filter.v.availability') && url.searchParams.get('catalog_availability') !== 'all') url.searchParams.set('filter.v.availability', '1');
      if (!url.searchParams.has('sort_by')) url.searchParams.set('sort_by', 'created-descending');
      load(url, false);
    });
    load(current, false);
  });
})();
